import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

export default {
  data: function() {
    return {
      functionsServer: process.env.VUE_APP_FUNCTIONS_SERVER
    }
  },
  methods: {
    postJSONWithAuth: async function(url, data) {
      return new Promise((resolve, reject) => {
        if(firebase.auth().currentUser != null) {
          firebase.auth().currentUser.getIdToken()
          .then((token) => {
            let toSend = (url.indexOf("http") != 0)? this.functionsServer + url : url
            this.$http.post(toSend, data, {
              headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
              },
              json: true,
            })
            .then((result) => {
              resolve(result)
            })
            .catch((error) => {
              reject(error)
            })
          })
          .catch((error) => {
            reject(error)
          })
        }
      })
    },
    postWithAuth: function(url, data) {
      return new Promise((resolve, reject) => {
        if(firebase.auth().currentUser != null) {
          firebase.auth().currentUser.getIdToken()
          .then((token) => {
            let toSend = (url.indexOf("http") != 0)? this.functionsServer + url : url
            this.$http.post(toSend, data, {
              headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              json: false,
            })
            .then((result) => {
              resolve(result)
            })
            .catch((error) => {
              reject(error)
            })
          })
          .catch((error) => {
            reject(error)
          })
        }
      })
    },
    getWithAuth: function(url) {
      return new Promise((resolve, reject) => {
        if(firebase.auth().currentUser != null) {
          firebase.auth().currentUser.getIdToken()
          .then((token) => {
            let toSend = (url.indexOf("http") != 0)? this.functionsServer + url : url
            this.$http.get(toSend, {
              headers: {
                'Authorization': 'Bearer ' + token,
              }
            })
            .then((result) => {
              resolve(result)
            })
            .catch((error) => {
              reject(error)
            })
          })
          .catch((error) => {
            reject(error)
          })
        }
      })
    },
    postJSON: function (url, data, config = {
        headers: {
          "Content-Type": "application/json"
        },
        json: true
      })
      {
      return new Promise((resolve, reject) => {
        let toSend = (url.indexOf("http") != 0)? this.functionsServer + url : url
        this.$http.post(toSend, data, config)
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
      })
    },
    postText: function (url, data, config = {
        headers: {
          "Content-Type": "text/plain"
        },
        json: false
      })
      {
      return new Promise((resolve, reject) => {
        let toSend = (url.indexOf("http") != 0)? this.functionsServer + url : url
        this.$http.post(toSend, data, config)
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
      })
    },
    post: function (url, data, config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        json: false
      }) {
      return new Promise((resolve, reject) => {
        let toSend = (url.indexOf("http") != 0)? this.functionsServer + url : url
        this.$http.post(toSend, data, config)
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
      })
    },
    get: function(url, config = {}) {
      return new Promise((resolve, reject) => {
        let toSend = (url.indexOf("http") != 0)? this.functionsServer + url : url
        this.$http.get(toSend, config)
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
      })
    },
  },
}